import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 文本框组件，继承Base
 * @module $ui/components/my-slider
 */

import { Slider } from 'element-ui';
import Base from '../Base';
export default {
  name: 'MySlider',
  mixins: [Base],
  components: {
    Slider: Slider
  },
  props: {
    value: Number
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      return 0;
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = h(Slider, {
      "ref": 'comp',
      "class": 'my-slider',
      "props": _objectSpread({}, this.innerProps),
      "on": _objectSpread({}, this.$listeners),
      "attrs": _objectSpread({}, this.innerProps),
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    });
    return this.renderComponent(vnode);
  }
};